import React from 'react'
import { Sm } from './Data';
import Flip from 'react-reveal/Flip';
import styled from 'styled-components';
const Container = styled.div`
  display:grid;
  grid-template-columns:repeat(auto-fill,350px);
  align-items:center;
  margin:auto;
`

const SocialMedia = () => {
  return (
    <Container>
      {Sm.map((data, index) => {
        return (
        <Flip left>
      <a className="ui link cards" key={index} href={data.link}>
            <div className="card">
  
        <div className="ui centered small image">
          <img className="ui centered small image"  src={data.image} alt={data.alt} />
        </div>
        <div className="content">
                <div className="header">{data.title}</div>
                <div className='meta'>{data.desc} </div>
                </div>    
              </div>   
            </a>
        </Flip>
    )})}
    </Container>

  )
}

export default SocialMedia
